import { useEffect, useRef } from 'react';

export default function LeafletMap({ center, zoom = 14, markers = [], circle = null, style = {}, onMapClick }) {
  const containerRef = useRef();
  const mapRef = useRef();
  const layerGroupRef = useRef();

  useEffect(() => {
    if (!window.L || !containerRef.current || mapRef.current) return;
    const L = window.L;
    const map = L.map(containerRef.current).setView(center || [5.359952, -4.008256], zoom);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap', maxZoom: 19,
    }).addTo(map);
    layerGroupRef.current = L.layerGroup().addTo(map);
    mapRef.current = map;
    if (onMapClick) map.on('click', e => onMapClick(e.latlng.lat, e.latlng.lng));
    return () => { map.remove(); mapRef.current = null; };
  }, []);

  useEffect(() => {
    if (!mapRef.current || !window.L || !layerGroupRef.current) return;
    const L = window.L;
    layerGroupRef.current.clearLayers();
    markers.forEach(m => {
      if (m.lat == null || m.lng == null) return;
      const icon = L.divIcon({
        className: '',
        html: `<div style="width:12px;height:12px;background:${m.color||'#1a73e8'};border:2px solid #fff;border-radius:50%;box-shadow:0 1px 4px rgba(0,0,0,0.4)"></div>`,
        iconSize: [12, 12], iconAnchor: [6, 6],
      });
      const mk = L.marker([m.lat, m.lng], { icon });
      if (m.popup) mk.bindPopup(m.popup);
      layerGroupRef.current.addLayer(mk);
    });
    if (circle) {
      L.circle([circle.lat, circle.lng], {
        radius: circle.radius, color: circle.color || '#1a73e8',
        fillColor: circle.color || '#1a73e8', fillOpacity: 0.1, weight: 2,
      }).addTo(layerGroupRef.current);
      L.marker([circle.lat, circle.lng], {
        icon: L.divIcon({ className: '', html: `<div style="width:16px;height:16px;background:#1a73e8;border:3px solid #fff;border-radius:50%;box-shadow:0 1px 6px rgba(0,0,0,0.5)"></div>`, iconSize:[16,16], iconAnchor:[8,8] })
      }).bindTooltip('École').addTo(layerGroupRef.current);
    }
    if (center && mapRef.current) mapRef.current.setView(center, mapRef.current.getZoom());
  }, [markers, circle, center]);

  return <div ref={containerRef} style={{ width: '100%', height: '400px', ...style }} />;
}
